import { useState } from 'react';
import { useNavigate } from 'react-router';
import { ClearFiltersButton } from '../../components/clearFiltersButton.tsx';
import { NavBar } from '../../components/navBar.tsx';
import { PageTitle } from '../../components/pageTitle.tsx';
import { RecordsExportDialog } from '../../components/records-export/recordsExportDialog.tsx';
import { useLoadMoreOnScroll } from '../../hooks/useLoadMoreOnScroll.ts';
import { useRecordsFilters } from '../../hooks/useRecordsFilters.ts';
import { Record } from '../../types/sharedTypeImpl.ts';
import { trpc, trpcClient } from '../../utils/trpc/trpc.ts';
import { IoqcListTable } from './ioqcListTable.tsx';
import { MeasurementDialog } from './measurementDialog.tsx';


export function IoqcList() {
    const [showCreateDialog, setShowCreateDialog] = useState(false);
    const [pendingExportRecord, setPendingExportRecord] = useState<Record | null>(null);

    const {
        searchTextInput,
        searchText,
        setSearchTextDebounced,
        setSearchTextImmediate,
        handleClearFilters,
    } = useRecordsFilters();


    const navigate = useNavigate();

    const recordsQuery = trpc.records.getInfinite.useInfiniteQuery({
        measurementType: 'ioqc',
        search: searchText,
        limit: 50,
    }, {
        getNextPageParam: (last) => last.nextCursor ?? null,
        placeholderData: (prev) => prev,//Prevents flickering when editing filters
    });

    useLoadMoreOnScroll(recordsQuery);


    const handleRecordDelete = async (record: Record) => {
        const description = `${record.equipmentDisplayName} - ${record.protocolPartDisplayName}`;
        if (window.confirm(`Are you sure you want to delete the following record?\n${description}`)) {
            try {
                await trpcClient.records.delete.mutate({ recordId: record._id! });
                recordsQuery.refetch();
            } catch (error) {
                alert('Failed to delete record');
            }
        }
    }


    const records = recordsQuery.data?.pages.flatMap(page => page.records) ?? [];
    return <>
        <PageTitle title='IOQC' />
        <NavBar />
        <div className='content' style={{ width: '1480px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button onClick={() => setShowCreateDialog(true)}>Create measurement</button>

                <div className='flex__spacer' />

                <input
                    style={{ marginLeft: '18px' }}
                    type='text'
                    placeholder='Search'
                    value={searchTextInput}
                    onChange={e => setSearchTextDebounced(e.target.value)}
                />
                <ClearFiltersButton onClick={handleClearFilters} />
            </div >

            <IoqcListTable
                isLoading={recordsQuery.isLoading}
                error={recordsQuery.error}
                records={records}
                onRecordDelete={handleRecordDelete}
                onRecordExport={(record) => setPendingExportRecord(record)}
                onSearchTextChange={setSearchTextImmediate}
            />

            {recordsQuery.hasNextPage && (
                <div className='list--loading-more'>Loading…</div>
            )}
        </div >

        <MeasurementDialog
            isOpen={showCreateDialog}
            onRecordCreated={(record) => navigate(`/record-view?id=${record._id}&mode=edit`)}
            onClose={() => setShowCreateDialog(false)}
        />

        {pendingExportRecord && <RecordsExportDialog
            record={pendingExportRecord}
            onClose={() => setPendingExportRecord(null)}
        />}
    </>
}
